<script lang="ts">
  interface Props {
    value: string
    placeholder?: string
  }

  let { value = $bindable(''), placeholder = 'Search…' }: Props = $props()
</script>

<input type="search" class="search-input" bind:value {placeholder} aria-label={placeholder} />

<style>
  .search-input {
    padding: 6px 10px;
    border: 1px solid var(--line-strong);
    border-radius: 4px;
    font-size: 0.875rem;
    min-width: 240px;
  }
  .search-input:focus {
    outline: 2px solid var(--brand);
    outline-offset: -1px;
  }
</style>
